import { Api } from "./Api";

const USER_URL=`/user`
export const login = async (email: string, password: string) => {
    try {
      const response = await Api.post(`${USER_URL}/login`, { email, password});
      localStorage.setItem('token', response.data.token);
      return response.data;
    } catch (error:any) {
      if (error.response) {
        return { error: error.response.data };
      } else {
        return { error: 'An error occurred while trying to log in' };
      }
    }
  };
  export const sendOTP = async (email: string) => {
    try {
      const response = await Api.post(
        `${USER_URL}/send_otp`,
        { email },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const verifyOtp = async (email:any, otp:any) => {
    try {
      const response = await Api.post(
        `${USER_URL}/verify_otp`,
        { email, otp },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
        
      );
      return response.data; // Return the API response
    } catch (error:any) {
      if (error.response) {
        console.error('Error verifying OTP:', error.response.data.message);
        return { error: error.response.data.message }; // Return server error message
      } else {
        console.error('Error verifying OTP:', error.message);
        return { error: 'An error occurred while verifying the OTP.' }; // Return general error
      }
    }
  };
  export const forgetPassword = async (email: string, password: string,otp: string) => {
    try {
      const response = await Api.post(
        `${USER_URL}/forgot_password`,
        { email, password,otp},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error resetting password:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error resetting password:', error.message);
        return { error: 'An error occurred while resetting the password.' };
      }
    }
  };
  export const getEnvData = async (environment: string) => {
    try {
      const response = await Api.put(
        `${USER_URL}/update/environment`,
        { environment},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting environment:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting environment:', error.message);
        return { error: 'An error occurred while getting the environment.' };
      }
    }
  };